(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDeleteController',CollectionIbqDeleteController);

    CollectionIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Collection'];

    function CollectionIbqDeleteController($uibModalInstance, entity, Collection) {
        var vm = this;

        vm.collection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Collection.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
